document.addEventListener('DOMContentLoaded', function () {
  const sections = document.querySelectorAll('.nf-blog-slider');
  if (sections.length === 0) return;

  sections.forEach(function (section) {
    const swiperEl = section.querySelector('.swiper');
    if (!swiperEl || !window.Swiper) return;

    new Swiper(swiperEl, {
      loop: false,
      spaceBetween: 8,
      slidesPerView: 1.25,
      mousewheel: {
        forceToAxis: true
      },
      navigation: {
        nextEl: section.querySelector('.swiper-button-next'),
        prevEl: section.querySelector('.swiper-button-prev')
      },
      breakpoints: {
        750: {
          spaceBetween: 24,
          slidesPerView: 3
        }
      }
    });
  });
});
